import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { checkAuthorization } from "../api/auth";
import { BASE_URL, AuthToken } from "../api/base";

const AffiliateLogin = () => {
    const { loginkey } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const verifyKey = async () => {
            try {
                const res = await fetch(`${BASE_URL}/VerifyAffiliateEXELogin`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "API_Key": AuthToken,
                    },
                    body: JSON.stringify({ LoginKey: loginkey }),
                });

                const data = await res.json();
                console.log("data", data);


                if (data.status === "Success" && data.Data.length > 0 && data.Data[0].AffiliateID != null) {
                    const affiliate = data.Data[0];
                    localStorage.setItem("ClassAffiliateID", affiliate.AffiliateID);
                    localStorage.setItem("AffiliateName", affiliate.AffiliateName);
                    localStorage.setItem("Mobile", affiliate.Mobile);
                    localStorage.setItem("EmailID", affiliate.EmailID);

                    navigate("/courses");
                } else {
                    navigate("/unauthorized");
                }
            } catch (err) {
                console.error(err);
                navigate("/unauthorized");
            }
        };

        verifyKey();
    }, [loginkey, navigate]);


    return <div></div>;
};

export default AffiliateLogin;
